import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

const Tabs = ({ titles, handleIndex, activeType }) => (
  <Root totalTabs={titles.length} index={activeType}>
    {titles.map((title, index) => (
      <Option
        key={index}
        onClick={() => handleIndex(index)}
        active={activeType === index}
      >
        {title}
      </Option>
    ))}
  </Root>
);

export default Tabs;

Tabs.propTypes = {
  titles: PropTypes.array,
  handleIndex: PropTypes.func,
  activeType: PropTypes.number,
};

const Root = styled.div`
  width: 100%;
  margin: 20px auto;
  position: relative;
  display: flex;
  justify-content: space-around;
  @media (min-width: ${media.mdup}) {
    display: block;
  }
  &::before {
    content: '';
    width: ${props => `calc(100% / ${props.totalTabs} - 5%)`};
    height: 4px;
    background-color: black;
    transition: 0.3s ease;
    position: absolute;
    left: ${props =>
      `calc(calc(100% / ${props.totalTabs}) * ${props.index} + 2.5%)`};
    top: 100%;
    @media (min-width: ${media.mdup}) {
      display: block;
      width: 4px;
      height: ${props => `calc(100% / ${props.totalTabs} - 20px)`};
      left: 0;
      top: ${props => (props.index === 0 ? '7px' : '64px')};
    }
  }
`;

const Option = styled.h1`
  transition: 0.3s ease;
  margin: 5px 10px;
  text-align: center;
  font-weight: 500;
  font-size: 22px;
  color: ${props =>
    props.active ? props.theme.colorPrimary : props.theme.colorLightGrey};
  cursor: pointer;
  width: 50%;
  @media (min-width: ${media.mdup}) {
    margin: 20px 10px;
    text-align: left;
    font-size: 30px;
  &:hover {
    color: ${props => props.theme.colorPrimary};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Floorplans/elements/Tabs.js